import { render, staticRenderFns } from "./actuals_tbn.vue?vue&type=template&id=1b6f6743&"
import script from "./actuals_tbn.vue?vue&type=script&lang=js&"
export * from "./actuals_tbn.vue?vue&type=script&lang=js&"
import style0 from "./actuals_tbn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports